import fetch from 'cross-fetch';

export const languagesMap = {
	en: 'English',
	es: 'Español',
	zh: '中文 (简体)',
	ko: '한국어',
	ja: '日本語',
	tl: 'Tagalog',
	vi: 'Vietnamese',
};

export const shortLanguagesMap = {
	en: 'Eng',
	es: 'Esp',
	zh: '中文',
	ko: '한국어',
	ja: '日本語',
	tl: 'Tgl',
	vi: 'Viet',
};

export function parseLang() {
	if (typeof window !== 'undefined') {
		const { localStorage, location } = window;
		const lang = location.pathname.split('/')[1];
		const needle = Object.keys(languagesMap).find((el) => el === lang);
		if (typeof needle !== 'undefined') {
			localStorage.removeItem('gatsby-i18next-language');
			localStorage.removeItem('wglang');
			localStorage.setItem('gatsby-i18next-language', needle);
			localStorage.setItem('wglang', needle);
		} else {
			localStorage.removeItem('gatsby-i18next-language');
			localStorage.removeItem('wglang');
			localStorage.setItem('gatsby-i18next-language', 'en');
			localStorage.setItem('wglang', 'en');
		}
	}
}

export function getPagePath(pageType, slug) {
	switch (pageType) {
	case 'Blog':
		return `/blog/${slug}`;
	case 'News':
		return `/news/${slug}`;
	default:
		return undefined;
	}
}

export function isInternalLink(link) {
	try {
		const url = new URL(link, window.location.origin);
		return url.hostname === window.location.hostname;
	} catch {
		return false;
	}
}

/**
 * Combines an array of functions in a composed function, right-to-left.
 * Used for function composition.
 *
 * @param {...Function} fns List of functions to be composed
 * @returns {Function} The composed functions
 **/
export function compose(...fns) {
	return fns.reduce(
		(prevFn, nextFn) =>
			(...args) =>
				prevFn(nextFn(...args)),
		(value) => value
	);
}

/**
 * Combines an array of functions in a composed function, left-to-right.
 * Used for function composition.
 *
 * @param {...Function} fns List of functions to be composed
 * @returns {Function} The composed functions
 **/
export function pipe(...fns) {
	return fns.reduceRight(
		(prevFn, nextFn) =>
			(...args) =>
				prevFn(nextFn(...args)),
		(value) => value
	);
}

export const fetchApiProducts = async (rows) => {
	let productsRequest = [],
		productsList = [];
	rows.map((products) => {
		products.tests.map((product) => {
			productsList.push(product.slug);
		});
	});

	for (let i = 0; i < productsList.length; i++) {
		const urls = `${process.env.GATSBY_MAGENTO_PROD_BASE}/rest/V1/covidclinic/products/${productsList[i]}`;
		productsRequest.push(urls);
	}
	const allRequests = productsRequest.map((url) =>
		fetch(url).then((response) => response.json())
	);
	const allPromise = Promise.all(allRequests);
	return allPromise;
};
